import Vue from 'vue';
import App from './App.vue';

import router from './router';
import store from './store';

import config from './config.js'
import {SYS, RE} from '@/config.js'
import library from '@deanwu/vue-component-library-mobile'
import '@deanwu/vue-component-library-mobile/dist/vue-component-library.css'
Vue.use(library, config);

import comps from './components/index.js'
Vue.use(comps);
import dialog from './components/dialog.js'
Vue.use(dialog);

Vue.prototype.SYS = SYS;
Vue.prototype.RE = RE;

Vue.prototype.$onShow = function(fun, once) {
	this.getApp().onShow(fun, once);
}
Vue.prototype.$offShow = function(fun) {
	this.getApp().offShow(fun);
}

Vue.prototype.setPageTitle = function(title) {
	if (this.$store.state.ENV == 'app') {
		this.JSBridge('setTitle', title);
	} else if (this.$store.state.ENV == 'ding') {
		dd.setNavigationTitle({title});
	} else {
		document.title = title;
	}
}

Vue.prototype.JSBridge = function(action, data, callback) {
	if (typeof data == 'function') {
		callback = data;
		data = undefined;
	}

	uni.postMessage({
		data: {
			action,
			data
		}
	});

	if (callback) {
		return new Promise(resolve => {
			window[`${action}Callback`] = data => {
				callback(data);
				delete window[`${action}Callback`];
				resolve();
			}
		});
	}
}

let wxReadyState = -1, wxReadyQueue = [];
Vue.prototype.WXReady = function(fun) {
	if (SYS != 'staff') return;

	if (this.$store.state.ENV == 'wechat' || this.$store.state.ENV == 'mp') {
		if (wxReadyState == 1) {
			fun();
			return;
		}
	} else if (this.$store.state.ENV != 'wxwork') {
		return;
	}

	fun && wxReadyQueue.push(fun);
	if (wxReadyState == 0) return;
	wxReadyState = 0;
	this.request({
		url: '/wechat/ticket',
		data: {
			type: this.$store.state.ENV == 'wxwork' ? 2 : 1,
			url: location.href.split('#')[0]
		},
		success: data => {
			wx.config({
				appId: data.appId,
				timestamp: data.timestamp,
				nonceStr: data.noncestr,
				signature: data.signature,
				jsApiList: ['scanQRCode', 'getLocation', 'openLocation']
			});

			wx.ready(() => {
				wxReadyState = 1;
				wxReadyQueue.forEach(fun => {
					try {
						fun();
					} catch(e) {}
				});
				wxReadyQueue = [];
			});
			
			wx.error(res => {
				this.$message({
					message: res.errMsg
				});
			});
		},
		fail: () => {
			this.$message({
				message: '微信签名获取失败'
			});
			return false;
		}
	});
}

Vue.prototype.takePhoto = function(config) {
	if (app.$store.state.ENV == 'mp') {
		app.$onShow(async key => {
			let data = await app.getCacheData(key);
			config.success(data);
		}, true);

		app.mp.navigateTo('/pages/power', {
			power: 'takePhoto',
			data: {
				wechatFile: config.wechatFile ? 1 : 0,
				count: config.count || 9,
				type: config.type
			}
		});
	} else {
		app.$upload(config);
	}
}

Vue.prototype.uploadFile = function(config, before) {
	if (app.$store.state.ENV == 'mp') {
		if (before) {
			app.$onShow(async key => {
				let data = await app.getCacheData(key);
				config.success(data);
			}, true);

			app.mp.navigateTo('/pages/power', {
				power: 'uploadFile',
				data: {
					wechatFile: config.wechatFile ? 1 : 0,
					count: config.count || 9,
					type: config.type
				}
			});
		} else {
			app.getApp().uploadFileHandle(config);
		}
	} else {
		app.$upload(config);
	}
}

Vue.prototype.getCacheData = function(key) {
	return new Promise(resolve => {
		app.request({
			url: '/cache/data',
			data: {
				key
			},
			success: data => {
				resolve(data ? JSON.parse(data) : data);
			}
		})
	});
}

// 获取APP.vue实例
Vue.prototype.getApp = function() {
	return app.$children[0];
};

// Alive.vue实例
Vue.prototype.getAlive = function() {
	return app.$children[0].$children.find(item => item.$options.name == 'Alive');
};

Vue.prototype.uploadConfig = function(opt) {
	window._uploadConfig = opt;
}

Vue.prototype.oss = function(url, w, h) {
	if (!url) return '';
	return `${url}?x-oss-process=image/resize,h_${h * 2},w_${w * 2}/quality,q_80`;
};

Vue.prototype.scanCode = function(opt) {
	opt = Object.assign({
		parse: true
	}, opt);
	new Promise(resolve => {
		if (['wechat', 'mp', 'wxwork'].includes(this.$store.state.ENV)) {
			this.WXReady(() => {
				wx.scanQRCode({
					needResult: 1,
					scanType: ['qrCode', 'barCode'],
					success: ({resultStr}) => {
						resolve(resultStr);
					},
					fail: res => {
						console.log(res);
					}
				});
			});
		} else if (this.$store.state.ENV == 'ding') {
			dd.scan({
				success: ({text}) => {
					resolve(text);
				}
			});
		} else if (this.$store.state.ENV == 'app') {
			this.JSBridge('scanCode', ({result}) => {
				resolve(result);
			});
		} else {
			this.$cameraScan({
				events: {
					resolve
				}
			});
		}
	}).then(res => {
		if (opt.parse) {
			try {
				let search;
				if (/http(s)?:/.test(res)) {
					search = new URL(res).search;
				} else {
					search = res;
				}
				let data = {};
				new URLSearchParams(search).forEach((value, key) => {
					data[key] = value;
				});
				opt.success(data);
			} catch(e) {
				this.$message({
					message: '二维码内容解析失败'
				});
			}
		} else {
			opt.success(res.replace(res.match(/^[A-Z]+_[A-Z\d]+,/), ''));
		}
	});
};

Vue.prototype.formEditConfirm = function($form, events) {
	if ($form.editState) {
		this.$confirm({
			message: '取消后已更改的数据将会丢失，确定要取消吗？',
			cancelButtonName: '继续编辑',
			resolve: () => {
				$form.setEditState(false);
				events();
			}
		})
	} else {
		events();
	}
};

Vue.prototype.moreButtonHandle = function(item) {
	item.event();
};

Vue.prototype.rem2px = function(rem) {
	return rem * parseFloat(getComputedStyle(document.documentElement)['font-size']);
}

Vue.prototype.px2rem = function(px) {
	return px / parseFloat(getComputedStyle(document.documentElement)['font-size']);
}

Vue.prototype.window = window;

Vue.config.productionTip = false;

const app = window.$app = new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app');
